import { LocalPhoneOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Grid from '@mui/material/Grid'
import React, { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import { FullPatientFragment } from 'src/participant/patientQueries.generated'
import { useIsCareCoordinator } from 'src/session'
import { PatientDetails } from 'src/participant/types'
import IntakeBookingContainerDialog from './IntakeBookingContainerDialog'
import { validateParticipantInfo, getMissingInfoMessage } from './validateParticipantInfo'
import { ParticipantWithBookingInformation } from '../types'

type Props = {
  participantWithBookingInformation: ParticipantWithBookingInformation
  participantWithFullInformation: FullPatientFragment
}

const ScheduleIntakeCall: React.FC<Props> = ({
  participantWithBookingInformation,
  participantWithFullInformation,
}: Props) => {
  const styles = useStyles()
  const isCareCoordinator = useIsCareCoordinator()
  const [inScheduleDialogOpen, setInScheduleDialogOpen] = useState<boolean>(false)

  const { addToast } = useToasts()

  const details = participantWithFullInformation.details as PatientDetails
  const validationResult = validateParticipantInfo(participantWithFullInformation, details)
  const { isValid, missingFieldLabels } = validationResult

  const onScheduleButtonClick = () => {
    if (isValid) {
      setInScheduleDialogOpen(true)
    } else {
      addToast(`Patient is missing information: ${getMissingInfoMessage(missingFieldLabels)}`, {
        appearance: 'error',
      })
    }
  }

  return (
    <>
      {inScheduleDialogOpen && (
        <IntakeBookingContainerDialog
          participant={participantWithBookingInformation}
          onCloseDialog={() => setInScheduleDialogOpen(false)}
        />
      )}
      <div className={styles.container}>
        <Grid container justifyContent="space-between" alignItems="center" px={1}>
          <Grid item>
            <Grid container>
              <LocalPhoneOutlined className={styles.phoneIcon} />
              <Typography variant="h6" className={styles.noScheduledIntakeCallText}>
                No intake call scheduled
              </Typography>
            </Grid>
          </Grid>
          {isCareCoordinator && (
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                className={styles.modifyButton}
                onClick={onScheduleButtonClick}
              >
                SCHEDULE
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#F3F5F3',
    borderRadius: 8,
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  phoneIcon: {
    alignSelf: 'center',
    marginRight: theme.spacing(2),
  },
  modifyButton: {
    marginRight: theme.spacing(1),
  },
  noScheduledIntakeCallText: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default ScheduleIntakeCall
